// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import './App.css';

/**
 * This component is used to display the required
 * terms of use statement which can be found in a
 * link in the about tab.
 */

const mapStateToProps = (state) => {
  return {
    userStatus: state.lognReducer
  }
}
class TermsOfUse extends React.Component {
  constructor() {
    super();
    this.state = {
      reDirect: '',
    }
  }
  componentDidMount = async () => {
    if (this.props.userStatus.userName === "") {
      this.setState({
        pageName: "termsofuse",
        reDirect: '/',
      })
    }
  }
  render() {
    if (this.state.reDirect) {
      return <Redirect
        to={{
          pathname: this.state.reDirect, state: {
            pageName: this.state.pageName
          }
        }} />
    }
    return (
      <div>
        <h4 style={{ marginTop: '10%', marginLeft: '20%' }}>terms of use- TBD</h4>
      </div>
    );
  }
}

export default connect(mapStateToProps)(TermsOfUse);